import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ISlideshow } from '../../pages/slideshows/slideshows.interface';
import { IBaseResponse } from '../../utilities/http-utilities.service';

@Injectable({ providedIn: 'root' })
export class SlideshowContentService {
  constructor(private readonly http: HttpClient) {}

  public getSlideshowContent(
    slideshowId: number,
    options: Parameters<HttpClient['get']>[1] = {},
  ): Observable<IBaseResponse<ISlideshow>> {
    return this.http.get<IBaseResponse<ISlideshow>>(`slideshows/${slideshowId}`, options);
  }
}
